export function getUnits(getValues, precision) {
  // data_rate_units is supplied by the backend from the product
  // definition (product.throughput_units) so there are no per-product
  // rules required here
  const equipment = getValues('local.radios.0.equipment');
  const { data_rate_units: dataRateUnits } = equipment;
  if (dataRateUnits === 'kbps') {
    // The product (e.g. cnReach) reports data rates in the kbps range.
    // Note: precision must not be 0 - the integer-only validation in
    // GenericScaledField checks the stored (Mbps) value, which is
    // fractional for kbps rates.
    return ['kbps', 2];
  }
  if (dataRateUnits === 'Gbps') {
    return ['Gbps', 3];
  }
  return ['Mbps', precision];
}
